var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Layout',[_c('Header',{class:_vm.$style.layout_header},[_c('PageHeader')],1),_vm._v(" "),_c('Content',{style:({margin: '20px 20px 20px 20px', minHeight: '570px'})},[_c('router-view',{attrs:{"id":"root_view"}})],1),_vm._v(" "),_c('Footer',{class:_vm.$style.layout_footer},[_c('PageFooter')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb834d7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/App.vue
// module id = null
// module chunks = 